import React from "react";
import { trackGdp } from "@/utils/gio-report";
import { getChannel } from "@/utils/tools";
import { goToPageV2 } from "@/utils/common";
import { ActivityDetailPopupRef } from "@/components/ActivityDetailPopup";
import "./index.less";

interface ActivityDetailButtonProps {
  // 按钮模式：description 直接传描述文本，activityCode 通过API获取
  mode: "description" | "activityCode";
  // 活动信息，用于埋点上报
  activityInfo: any;
  // 数据源：描述文本或activityCode
  data: string;
  // 活动详情弹窗引用
  activityDetailPopupRef?: React.RefObject<ActivityDetailPopupRef>;
  // 按钮图片URL
  buttonImage: string;
  // 按钮样式类名
  className?: string;
  // 自定义样式
  style?: React.CSSProperties;
  // 组件样式类型：ranking（img标签） 或 lottery（span标签）
  componentType?: "ranking" | "lottery";
  // 可选的activityId，用于description模式的埋点
  activityId?: string;
}

const ActivityDetailButton: React.FC<ActivityDetailButtonProps> = ({
  mode,
  activityInfo,
  data,
  activityDetailPopupRef,
  buttonImage,
  className = "",
  style = {},
  componentType = "ranking",
  activityId,
}) => {
  const handleClick = () => {
    // 埋点上报 - 保持与原组件一致的逻辑
    const trackData: any = {
      trackName: "充电_营销专题页_组件点击",
      origin: getChannel(),
      userType: "",
      versionId: activityInfo.versionCode,
      pageId: activityInfo.pageCode,
      ComponentCode: activityInfo.moduleId,
      type: activityInfo.moduleType,
      activityId:
        mode === "description"
          ? activityId || activityInfo.connectedActivitiesId
          : activityInfo.connectedActivitiesId,
      clickLocation: "活动详情",
    };

    // 根据组件类型添加不同的样式参数
    if (componentType === "ranking") {
      // Ranking组件的埋点参数
      trackData.comp_style = activityInfo.moduleJson
        ? JSON.parse(activityInfo.moduleJson).visual?.visualData[0]?.typeName
        : "";
      trackData.status = activityInfo.status || "";
    } else {
      // Lottery组件的埋点参数
      trackData.comp_style = activityInfo.moduleJson
        ? JSON.parse(activityInfo.moduleJson).visual?.visualData[0]?.typeName
        : "";
      trackData.status = "";
    }

    trackGdp("P20189", "B004", trackData);

    // 如果传入了弹窗引用，使用弹窗；否则使用页面跳转
    if (activityDetailPopupRef && activityDetailPopupRef.current) {
      if (mode === "description") {
        // 直接传入描述文本模式（Ranking组件使用）
        activityDetailPopupRef.current.openWithDescription(
          data,
          activityId || activityInfo.connectedActivitiesId,
          activityInfo,
        );
      } else {
        // 通过activityCode获取详情模式（Lottery组件使用）
        activityDetailPopupRef.current.openWithActivityCode(data, activityInfo);
      }
    } else {
      // 向后兼容，保持原有的页面跳转逻辑
      if (mode === "description") {
        // Ranking模式的页面跳转（原rankingDetail.tsx逻辑）
        const activityDescribe = encodeURIComponent(JSON.stringify(data));
        goToPageV2({
          hash: `/activityDetailPage?activityDescribe=${activityDescribe}&activityId=${activityId || activityInfo.connectedActivitiesId}`,
        });
      } else {
        // Lottery模式的页面跳转（原TopButtonGroup逻辑）
        goToPageV2({
          hash: `/activityDetail?activityCode=${data}`,
        });
      }
    }
  };

  // 根据组件类型渲染不同的元素
  if (componentType === "ranking") {
    // Ranking组件样式：img标签
    return (
      <img
        src={buttonImage}
        className={`activity-detail-button ranking-style ${className}`}
        style={style}
        onClick={handleClick}
        alt="活动详情"
      />
    );
  } else {
    // Lottery组件样式：span标签
    return (
      <span
        className={`activity-detail-button lottery-style ${className}`}
        style={{
          background: `url(${buttonImage}) 0 0 / cover no-repeat`,
          ...style,
        }}
        onClick={handleClick}
      />
    );
  }
};

export default ActivityDetailButton;
